module.exports = __webpack_public_path__ + "img/delete.94b8edc0.svg";